import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AttendenceRoutingModule } from './attendence-routing.module';
import { AddAttendanceComponent } from './add-attendance/add-attendance.component';
import { EditAttendanceComponent } from './edit-attendance/edit-attendance.component';
import { ViewAttendanceComponent } from './view-attendance/view-attendance.component';
import { AttendanceListComponent } from './attendance-list/attendance-list.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { PipeModule } from 'app/shared/pipes/pipe.module';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { CustomFormsModule } from 'ngx-custom-validators';
import { NgxSpinnerModule } from 'ngx-spinner';

@NgModule({
  declarations: [
    AddAttendanceComponent,
    EditAttendanceComponent,
    ViewAttendanceComponent,
    AttendanceListComponent,
    
  ],
  imports: [
    CommonModule,
    AttendenceRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgbModule,
    SwiperModule,
    PipeModule,
    NgxDatatableModule,
    CustomFormsModule,  
    NgxSpinnerModule
  ]
})
export class AttendenceModule { }
